module.exports = __webpack_public_path__ + "static/media/logo.b9273eb4.png";